<script setup>
import { reactive, ref, watch, inject, computed } from "vue";
import { Icon } from "@iconify/vue";
import { useI18n } from "vue-i18n";

import { useElements } from "../../../composables/elements";

const props = defineProps({
  websiteId: { type: Number, required: true },
  pageId: { type: Number, required: true },
  element: { type: Object, required: true },
});
const copying = ref(false);
const { t } = useI18n();
const {
  storeElement,
} = useElements();

const copyElement = async () => {
  copying.value = true;
  await storeElement(props.element.id, {
    websiteId: props.websiteId,
    pageId: props.pageId,
    order: props.element.order + 1,
    ...props.element
  }).then(() => copying.value = false);
}

</script>

<template>
  <div class="copy-element">
    <div class="copy-btn">
      <Icon icon="bi:copy" width="32" height="32" @click="copyElement" v-if="!copying" />
      <Icon icon="line-md:loading-loop" width="32" height="32" v-if="copying" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.copy-element {
  background: #fff;
  border-radius: 50%;
  position: absolute;
  padding: 6px;
  border-radius: 6px;
  border: 2px solid #000;
}
</style>
